import React from 'react';
import QRPreview from '../shared/QRPreview';

const DesktopQRTab = ({ propertyTab, portfolio }) => {
  return <QRPreview variant="desktop" propertyTab={propertyTab} portfolio={portfolio} />;
};

export default DesktopQRTab;
